import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
import TextNumberInput from "../../widgets/TextNumberInput";
import FixButton from "../../widgets/Button";
import EmptyPage from "../../widgets/EmptyPage";
import TimezoneSelect from "../../widgets/TimezoneSelect";
import GetEventService from "../../services/getEvent";
import MyDatePicker from "../../widgets/DatePicker";
import ImageInput from "../../widgets/ImageInput";
import BooleanInput from "../../widgets/BooleanInput";
import SaveEvent from "../../services/manageEvent";
import moment from 'moment';
import { Editor } from 'react-draft-wysiwyg';
import allMeetingsExcel from '../../utils/excel/allMeetings';
import draftToHtml from 'draftjs-to-html';
import SendMail from '../../services/sendMail';

import Utils from '../../utils/utils';

export default class EventDetails extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.renderCount = 0;

    this.state = {
      event: undefined,
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
    }

    this.grid = 2;

    this.pageTitle = "Event details";

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });
    this.savedEnabled = false;

    let event = await GetEventService(username, token, currentEventId);
    if (event == undefined){
      this.setState({});
      return;
    }

    var contentState = {};
    var notes = event.notesRaw;
    if (notes != '') {
        var json = JSON.parse(notes);
        contentState = json;
    } else {
        notes = '{"blocks":[{"key":"","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';
        var json = JSON.parse(notes);
        contentState = json;
    }
    
    this.setState({ event, contentState });
  }

  onContentStateChange = contentState => {
    this.savedEnabled = true;
    this.setState({ contentState });

  }

  shouldComponentUpdate(nextProps, nextState) {
    console.log(nextState);
    if (this.renderCount < 2) {
        this.renderCount += 1;
        return true;
    } else {
        return false;
    }
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
      { id: 'name', numeric: true, disablePadding: false, label: 'Name' },
      { id: 'surname', numeric: true, disablePadding: false, label: 'Surname' },
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    const cookies = new Cookies();
    const currentEventName = cookies.get('currentEventName', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });

    if (currentEventName == '' || currentEventName == undefined){
      return <EmptyPage />;
    }

    if (this.state.event == undefined) return <div />;

    function completeTime(uncomplete){
      if (uncomplete.length >= 2) return uncomplete;
      if (uncomplete.length == 0) return "00";
      return "0"+uncomplete;
      
    }


    let strStartDate = this.state.event.startDate + " " + completeTime(this.state.event.startHour) + ":" + completeTime(this.state.event.startMinutes);
    let xStartDate = moment(strStartDate, 'DD/MM/yyyy HH:mm').toDate();
    let strEndDate = this.state.event.endDate + " " + completeTime(this.state.event.endHour) + ":" + completeTime(this.state.event.endMinutes);
    let xEndDate = moment(strEndDate, 'DD/MM/yyyy HH:mm').toDate();


    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />

        <FixButton title={'Download all meetings Excel'} callback={async () => {
            allMeetingsExcel();
        }} />

          <TextInput name={'Event name'} value={this.state.event.eventName} 
          onChange={(val) => 
            this.setState(prevState => ({
              event: {
                ...prevState.event, 
                eventName: val
              }
            }))
            } />
          <TextNumberInput name={'Slot duration'} value={this.state.event.slotDuration * 5} 
          onChange={(val) =>        
            this.setState(prevState => ({
              event: {
                ...prevState.event, 
                slotDuration: prevState.event.slotDuration < (val / 5) ? Math.ceil(val / 5) : Math.trunc(val / 5)
              }
            }))
            } />
          <MyDatePicker readOnly={true} ref={this.startDateRef} name={'Start date'} value={xStartDate} />
          <MyDatePicker readOnly={true} ref={this.endDateRef} name={'End date'} value={xEndDate} />

          <TimezoneSelect name={'Timezone'} value={this.state.event.timezone} handleChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  timezone: val
                }
              }))} />

          <TextInput name={'Timezone information'} value={this.state.event.timezoneInformation} 
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  timezoneInformation: val
                }
              })) }
          />

          <ImageInput name={'Banner image'} key={Math.random()} 
            value={this.state.event.bannerImage}
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  bannerImage: val
                }
              }))
              }
          />

          <ImageInput name={'Brokers banner'} key={Math.random()} 
            value={this.state.event.brokers_banner}
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  brokers_banner: val
                }
              })) }
          />

          <TextInput name={'Custom breaks (separated by ;)'} value={this.state.event.customBreaks} 
            onChange={(text) => {               
              this.setState(prevState => ({
              event: {
                ...prevState.event, 
                customBreaks: text
              }
            }))}
          } />

        <div style={{margin: 10}}>Event notes:</div>
        <div style={{width: '500px', margin: 10, border: '1px solid black', padding: '10px', background: '#ffffff'}}>
            <Editor

                contentState={this.state.contentState}
                onContentStateChange={this.onContentStateChange}
                toolbarClassName="demo-toolbar-custom"
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor-custom"
                toolbar={{
                    options: ['inline', 'fontSize', 'fontFamily', 'colorPicker', 'link'],       
                    inline: {
                        options: ['bold', 'italic', 'underline'],
                        bold: { className: 'bordered-option-classname' },
                        italic: { className: 'bordered-option-classname' },
                        underline: { className: 'bordered-option-classname' },
                    },
                }}
            />
        </div>
      

          <BooleanInput key={Math.random()} name={'Intermediaries can visualize investor schedules'} 
            value={this.state.event.brokersInvestorViewEnabled == "1" ? true : false} 
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  brokersInvestorViewEnabled: val == true ? 1 : 0
                }
              })) }
          />

          <div style={{marginLeft: 10}}>Show intermediary information on schedules:</div>
          <BooleanInput key={Math.random()} name={'for Investors'} 
            value={this.state.event.brokersInfoSchedulesEnabled == "1" ? true : false} 
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  brokersInfoSchedulesEnabled: val == true ? 1 : 0
                }
              })) }
          />
          <BooleanInput key={Math.random()} name={'for Companies'} 
            value={this.state.event.brokersInfoSchedulesCompaniesEnabled == "1" ? true : false} 
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  brokersInfoSchedulesCompaniesEnabled: val == true ? 1 : 0
                }
              })) }
          />

          <TextInput name={'Mail user'} value={this.state.event.mailUser} 
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  mailUser: val
                }
              })) }
          />
          <TextInput name={'Mail password'} value={this.state.event.mailPassword} 
            onChange={(val) =>           
              this.setState(prevState => ({
                event: {
                  ...prevState.event, 
                  mailPassword: val
                }
              })) }
          />
          <FixButton title={'Test send mail'} callback={async () => {

              var address = this.state.event.mailUser;
              var password = this.state.event.mailPassword;

              await SendMail('', '', address, address, password, address, '', '', '', '', '', 'Test message', 'If you can see this message it means that it works!');
              alert ('Test message sent');
          }} />
          <br/>
          


          <FixButton title={'Save'} callback={async () => {
              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              const adminId = cookies.get('adminId', { path: '/' });

              var n = this.state.contentState; 
              n.blocks.forEach((block) => {
                  block.inlineStyleRanges.forEach((s, ind) => {
                      if (s.style !== 'BOLD' && s.style !== 'ITALIC' && s.style !== 'UNDERLINE' && !s.style.includes('color-rgb') && !s.style.includes('fontsize') && !s.style.includes('fontfamily')) {
                          s.style = "";
                      }
                  })

                  block.text = block.text.replace(/\n/g, '');
              });
              n.blocks.forEach((block, ind) => {
                  if (block.text === '') {
                      n.blocks.splice(ind, 1);
                  }
              });
              const notesRaw = JSON.stringify(this.state.contentState);
    
              var notes = this.state.event.notes;
              var newNote = n
              notes = draftToHtml(newNote);
              notes = notes.replace(/<p>/g, '<p style="line-height: normal; background-color: #ffffff">');
              notes = notes.replace(/><\/p>/g, '><br></p>');
              
              let ret = await SaveEvent(username, token, adminId, false, this.state.event.eventId,
                this.state.event.eventName, 
                this.state.event.startDate, this.state.event.startHour, this.state.event.startMinutes,
                this.state.event.endDate, this.state.event.endHour, this.state.event.endMinutes,
                this.state.event.slotDuration, this.state.event.bannerImage, 
                this.state.event.brokers_banner,
                this.state.event.brokersInvestorViewEnabled, 
                this.state.event.mailUser,
                this.state.event.mailPassword, 
                '', '', 
                this.state.event.brokersInfoSchedulesEnabled,
                this.state.event.brokersInfoSchedulesCompaniesEnabled,
                notes, notesRaw, this.state.event.customBreaks, this.state.event.timezone, this.state.event.timezoneInformation
                )

                if (ret.result == 'ok'){
                  alert ('Saved successfully');
                }
                else {
                  alert ('An error happened');
                }
          }} />

        </LoadingOverlay>
      </>
    );
  }

}

